import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["list", "template"]
  static values = { duration: Number }

  connect() {
    const form = this.element.closest("form")
    this.durationInput = form?.querySelector("input[name='duty_block_template[duration_days]']")
    this.onDurationInput = () => {
      this.durationValue = parseInt(this.durationInput.value, 10) || 1
    }
    this.durationInput?.addEventListener("input", this.onDurationInput)
  }

  disconnect() {
    this.durationInput?.removeEventListener("input", this.onDurationInput)
  }

  add() {
    const nextIndex = this.listTarget.querySelectorAll("[data-position-row]").length + 1
    const html = this.templateTarget.innerHTML.replaceAll("__INDEX__", nextIndex)
    this.listTarget.insertAdjacentHTML("beforeend", html)
    this.syncAllRowsToDuration()
  }

  remove(event) {
    event.currentTarget.closest("[data-position-row]").remove()
  }

  durationValueChanged() {
    if (this.hasListTarget) this.syncAllRowsToDuration()
  }

  syncAllRowsToDuration() {
    const target = this.durationValue
    this.listTarget.querySelectorAll("[data-position-row]").forEach((row) => {
      const container = row.querySelector("[data-day-selects]")
      const blueprint = row.querySelector("[data-day-select-template]")?.innerHTML
      if (!container || !blueprint) return
      let selects = container.querySelectorAll("[data-day-select]")
      while (selects.length < target) {
        container.insertAdjacentHTML("beforeend", blueprint)
        selects = container.querySelectorAll("[data-day-select]")
      }
      while (selects.length > target) {
        selects[selects.length - 1].remove()
        selects = container.querySelectorAll("[data-day-select]")
      }
    })
  }
}
